module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.contactElements), function(element) {
    return _c('div', {
      key: element.key,
      staticClass: "workflow-contact clickable",
      on: {
        "click": function($event) {
          return _vm.contactClicked(element)
        }
      }
    }, [_c('div', {
      staticClass: "truncate"
    }, [_vm._v(_vm._s(_vm._f("fullName")(element.contact)))]), _vm._v(" "), _c('div', {
      staticClass: "truncate",
      staticStyle: {
        "text-transform": "uppercase",
        "font-size": "9px"
      }
    }, [(element.contact.preferredName) ? _c('div', {
      staticStyle: {
        "font-size": "11px",
        "background-color": "yellow",
        "display": "inline-block",
        "line-height": "0.9em"
      }
    }, [_vm._v("Prefer " + _vm._s(element.contact.preferredName))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(element.roles.join('/')))])]), _vm._v(" "), _c('ContactImage', {
      attrs: {
        "contact": element.contact,
        "size": 46
      }
    }), _vm._v(" "), (!element.contact.notes) ? _c('div', {
      staticStyle: {
        "margin-top": "0px"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.bestNumber(element.contact)) + "\n        ")]) : _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('div', _vm._g({
            staticStyle: {
              "text-decoration": "underline",
              "text-decoration-style": "double",
              "text-decoration-color": "#aaa",
              "margin-top": "-8px"
            }
          }, on), [_vm._v("\n                    " + _vm._s(_vm.bestNumber(element.contact)) + "\n                ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(element.contact.notes))])])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dcd0382"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TransactionContacts.vue
// module id = 2516
// module chunks = 1